import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, unref as _unref } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-center" }
const _hoisted_3 = { class: "element-header mb-3 mb-lg-0" }
const _hoisted_4 = { class: "row g-2 w-100 w-lg-auto m-0 justify-content-end" }
const _hoisted_5 = { class: "col-12 col-sm-auto pr-3 pl-0" }
const _hoisted_6 = { class: "col-12 col-sm-auto p-0 mt-3 mt-sm-0" }
const _hoisted_7 = { class: "element-box mt-3" }
const _hoisted_8 = { class: "form-header mb-4" }
const _hoisted_9 = { class: "table-responsive overflow-auto pt-4" }
const _hoisted_10 = { class: "table table-striped" }
const _hoisted_11 = { style: {"text-align":"right","padding-right":"30px","min-width":"150px"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import coursePriceCoachingService from "@/api/Course/SocioTherapyCoaching";
import Modal from "@/components/modal/Modal.vue";
import PrimaryTypePriceForm from "@/views/App/Course/SocioTherapyCoaching/PrimaryTypePriceForm.vue";
import {piniaEnumsStore} from "@/store/piniaEnumsStore";
import SubstituteTypePriceForm from "@/views/App/Course/SocioTherapyCoaching/SubstituteTypePriceForm.vue";
import {IFilters, IPriceList, ISelectOption} from "@/interfaces/Course/SocioTherapy/ICoursePrice";
import Search from "@/views/App/Course/SocioTherapyCoaching/Search.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceList',
  setup(__props) {

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const isLoaded = ref(false);
const priceId = ref<number | null>(null)
const showPrimaryFormModal = ref(false);
const showSubstituteFormModal = ref(false);
const primaryTypeDropdown = ref<ISelectOption[]>([])
const substituteTypeDropdown = ref<ISelectOption[]>([])
const showDeleteModal = ref(false)
const submitForm = ref(false);
const isSearching = ref(false);
const operationTypeDropdown = ref<ISelectOption[]>([])
const priceTypeDropdown = ref<ISelectOption[]>([])

const filters = ref<IFilters>({
  operationType: '',
  priceType: '',
});


const priceList = ref<IPriceList>();

watch(submitForm, () => {
  priceId.value = null;
  showPrimaryFormModal.value = false;
  showSubstituteFormModal.value = false;
  showDeleteModal.value = false;
  getPriceList();
});

async function getPriceList(
    page: number | undefined = 1,
    perPage?: number,
    passedFilters?: IFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  const perPageRes = priceList.value?.pagination?.items_per_page;

  try {
    const {data} = await coursePriceCoachingService.getPriceList({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    priceList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function deletePrice() {
  if (priceId.value === null) return;

  try {
    await coursePriceCoachingService.deletePrice(+priceId.value);

    priceId.value = null;
    showDeleteModal.value = false;

    await getPriceList();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}


function handlePrimaryPriceModalForm(id?: number) {
  CloseToast()
  priceId.value = id ?? null
  showPrimaryFormModal.value = true;
  showSubstituteFormModal.value = false;
  showDeleteModal.value = false;
}

function handleSubstitutePriceModalForm(id?: number) {
  CloseToast()
  priceId.value = id ?? null
  showSubstituteFormModal.value = true;
  showPrimaryFormModal.value = false;
  showDeleteModal.value = false;
}

function handleModalDelete(id: number) {
  CloseToast()
  priceId.value = id;
  showDeleteModal.value = true;
  showPrimaryFormModal.value = false;
  showSubstituteFormModal.value = false;
}

function generateMeetingTypeDropdown() {
  primaryTypeDropdown.value = [
    {label: "Hausbesuch", value: "home_visit"},
    ...getEnums.value.socioTherapyMeetingTypes
  ];

  substituteTypeDropdown.value = [
    {label: "Hausbesuch", value: "home_visit"},
    ...getEnums.value.socioTherapyMeetingTypes2
  ];
  // substituteTypeDropdown.value = getEnums.value.socioTherapyMeetingTypes2

  operationTypeDropdown.value = getEnums.value.socioTherapyOperationTypes
  priceTypeDropdown.value = [...primaryTypeDropdown.value, ...substituteTypeDropdown.value]
}

function showHalfPrice(priceType: string) {
  return [
    "outreaching",
    "outreaching_office",
    "video_call",
    "telephone",
    "sociotherapy",
    "initial_consultation"
  ].includes(priceType);
}

function showTenMinutesPricePrice(priceType: string) {
  return [
    "sociotherapy",
    "initial_consultation"
  ].includes(priceType);
}

onMounted(async () => {
  await Promise.all([
    getPriceList()
  ]);

  generateMeetingTypeDropdown();
  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t('course.general_title')), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(CreateButton, {
                    class: "w-100",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handlePrimaryPriceModalForm())),
                    label: _ctx.$t('course.socio_therapy_coaching.title_primary_type_price')
                  }, null, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(CreateButton, {
                    class: "w-100",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSubstitutePriceModalForm())),
                    label: _ctx.$t('course.socio_therapy_coaching.title_substitute_type_price')
                  }, null, 8, ["label"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.list')), 1),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                operationTypeDropdown: operationTypeDropdown.value,
                priceTypeDropdown: priceTypeDropdown.value,
                onSearch: getPriceList
              }, null, 8, ["filters", "loading", "operationTypeDropdown", "priceTypeDropdown"]),
              _createVNode(PerPage, {
                values: [10, 25, 50, 100],
                "onUpdate:perPage": getPriceList
              }),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.operation_type')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.price_type')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.start_from')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.valid_till')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.price')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.half_price')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.ten_minutes_price')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.price_description')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.half_price_description')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('course.socio_therapy_coaching.ten_minutes_price_description')), 1),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('general.actions')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceList.value?.data, (price) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: price.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(price?.operationTypeTranslation), 1),
                        _createElementVNode("td", null, _toDisplayString(price?.priceTypeTranslation), 1),
                        _createElementVNode("td", null, _toDisplayString(price?.startFrom), 1),
                        _createElementVNode("td", null, _toDisplayString(price?.validTill), 1),
                        _createElementVNode("td", null, _toDisplayString(Number(price?.price).toFixed(2)), 1),
                        _createElementVNode("td", null, [
                          (showHalfPrice(price.priceType))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(Number(price?.halfPrice).toFixed(2)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          (showTenMinutesPricePrice(price.priceType))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(Number(price?.tenMinutesPrice).toFixed(2)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(price?.priceDescription), 1),
                        _createElementVNode("td", null, [
                          (showHalfPrice(price.priceType))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(price?.halfPriceDescription), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          (showTenMinutesPricePrice(price.priceType))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(price?.tenMinutesPriceDescription), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_16, [
                          (price.operationType === 'sociotherapie_primary')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary",
                                onClick: ($event: any) => (handlePrimaryPriceModalForm(price.id))
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "os-icon os-icon-edit" }, null, -1)
                              ]))], 8, _hoisted_17))
                            : _createCommentVNode("", true),
                          (price.operationType === 'sociotherapie')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-primary",
                                onClick: ($event: any) => (handleSubstitutePriceModalForm(price.id))
                              }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "os-icon os-icon-edit" }, null, -1)
                              ]))], 8, _hoisted_18))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn btn-danger ml-2",
                            onClick: ($event: any) => (handleModalDelete(price.id!))
                          }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "os-icon os-icon-trash" }, null, -1)
                          ]))], 8, _hoisted_19)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (priceList.value?.pagination?.total_pages ?? 0 > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    totalPages: priceList.value?.pagination?.total_pages,
                    currentPage: priceList.value?.pagination?.current_page,
                    totalItems: priceList.value?.pagination?.total_items,
                    perPage: priceList.value?.pagination?.items_per_page,
                    onPagechanged: getPriceList
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ])),
      _createVNode(Modal, {
        modelValue: showPrimaryFormModal.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showPrimaryFormModal).value = $event)),
        title: _ctx.$t('course.socio_therapy_coaching.title_primary_type_price'),
        "hide-cancel": true,
        "button-label": _ctx.$t('general.button.save'),
        customWidth: '800px',
        "hide-footer": true,
        classFooter: "justify-content-center"
      }, {
        default: _withCtx(() => [
          _createVNode(PrimaryTypePriceForm, {
            priceId: priceId.value,
            meetingTypeDropdown: primaryTypeDropdown.value,
            submitForm: submitForm.value,
            "onUpdate:submitForm": _cache[2] || (_cache[2] = ($event: any) => ((submitForm).value = $event))
          }, null, 8, ["priceId", "meetingTypeDropdown", "submitForm"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "button-label"]),
      _createVNode(Modal, {
        modelValue: showSubstituteFormModal.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showSubstituteFormModal).value = $event)),
        title: _ctx.$t('course.socio_therapy_coaching.title_substitute_type_price'),
        "hide-cancel": true,
        "button-label": _ctx.$t('general.button.save'),
        customWidth: '800px',
        "hide-footer": true,
        classFooter: "justify-content-center"
      }, {
        default: _withCtx(() => [
          _createVNode(SubstituteTypePriceForm, {
            priceId: priceId.value,
            meetingTypeDropdown: substituteTypeDropdown.value,
            submitForm: submitForm.value,
            "onUpdate:submitForm": _cache[4] || (_cache[4] = ($event: any) => ((submitForm).value = $event))
          }, null, 8, ["priceId", "meetingTypeDropdown", "submitForm"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "button-label"]),
      _createVNode(ModalDelete, {
        modelValue: showDeleteModal.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showDeleteModal).value = $event)),
        header: _unref(t)('general.delete_item_header'),
        onDelete: deletePrice
      }, null, 8, ["modelValue", "header"])
    ]),
    _: 1
  }))
}
}

})